/**
 * Configuration for Web Storage (localStorage) keys used by the customer dashboard.
 */
export const STORAGE_KEYS = {
  /** Login auth user id (`data.user.id` from customer auth). */
  AUTH_USER_ID: 'id',
  /** Workspace customer id from JWT `customerId` claim / profile. */
  CUSTOMER_ID: 'customer_id',
  /** Current FCM registration token for web push (deactivated on logout). */
  FCM_DEVICE_TOKEN: 'fcm_device_token',
} as const;
